import { __assign } from "tslib";
import React from 'react';
import { Stepper as MaterialStepper } from '@material-ui/core';
import { Step } from './Step';
import { StepLabel } from './StepLabel';
export var Stepper = function (props) {
    return React.createElement(MaterialStepper, __assign({}, props));
};
Stepper.Step = Step;
Stepper.StepLabel = StepLabel;
//# sourceMappingURL=Stepper.js.map